import { get } from "@rails/request.js"
import { Controller } from 'stimulus'; 

export default class extends Controller {

  static targets = ["customerSelect", "shipperSelect"];

  async customerChange(event) {

    const customerId = this.customerSelectTarget.value;
    const shipperPath = this.customerSelectTarget.getAttribute("data-shipper-path").replace(":id", customerId);

    const response = await get(shipperPath);
    const shipper = await response.text;

    this.shipperSelectTarget.value = shipper;
  }

}
